import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                艳
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                艳姆系列
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed max-w-md">
              艳姆1—6系列是备受关注的动画系列作品。我们致力于为观众提供全面的系列介绍、剧情解析与观看指引，帮助每一位爱好者更深入地理解和欣赏这一优秀作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-400 hover:text-background-100 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="/about#contact" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 艳姆系列解析站 — 本站内容仅供学习与交流参考
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              使用条款
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}